// Copyright © 2022 Move Closer

import {
  ApiConnectorType,
  AppModule,
  Container,
  IConfiguration,
  IConnector,
  Interfaces,
  Module
} from '@movecloser/front-core'

import { FormRepositoryType, IFormRepository } from './contracts'
import { FormRepository } from './repositories/forms'
import { resources } from './resources'

@AppModule({
  name: 'forms',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  providers: (config: IConfiguration) => {
    return (bind: Interfaces.Bind) => {
      bind<IFormRepository>(FormRepositoryType).to(FormRepository)
    }
  },

  boot: (container: Container) => {
    const connector: IConnector = container.get(ApiConnectorType)
    connector.useResources(resources)
  }
})
export class FormModule extends Module {}
